import React, { useContext } from 'react';

import LogoWhite from '../../../assets/images/header/Logo_CR_vertical_BRANCO_SEM-SLOGAN_01.png';
import { GeneralContext } from '../../../core/app-context/GeneralContext';
import InputSearch from './components/InputSearch';
import Perfil from './components/Perfil';
import { HeaderMenu } from './styles';

function HeaderApp() {
  const { menuOpen, setMenuOpen } = useContext(GeneralContext);

  return (
    <HeaderMenu onClick={() => menuOpen && setMenuOpen(false)}>
      <div id="container-logo-header">
        <img src={LogoWhite} alt="Logo clique retire" />
      </div>
      <div id="container-settings-header">
        <InputSearch />
        <div id="container-user">
          {/* <button onClick={() => handleChangeLanguage('pt-BR')}>BR</button>
          <button onClick={() => handleChangeLanguage('en-US')}>US</button> */}
          <Perfil menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        </div>
      </div>
    </HeaderMenu>
  );
}

export default HeaderApp;
